import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  FaArrowRight,
  FaBalanceScale,
  FaClipboardCheck,
  FaFolderOpen,
  FaEye,
  FaEyeSlash,
  FaLayerGroup,
} from "react-icons/fa";
import { useAuthContext } from "../../context/authContext";
import { useToastOnLoad } from "../../Hooks/useToastOnLoad";
import Logo from "../../Imagens/logoPentagov.jpg";
import "./index.css";
import "bootstrap/dist/css/bootstrap.min.css";

const Index = () => {
  const navigate = useNavigate();
  useToastOnLoad();
  const [usuario, setUsuario] = useState("");
  const [password, setPassword] = useState("");
  const [passwordVisible, setPasswordVisible] = useState(false);
  const { login } = useAuthContext();
  const presentationItems = [
    {
      icon: <FaBalanceScale />,
      title: "Governança",
      description: "",
    },
    {
      icon: <FaFolderOpen />,
      title: "Guarda Documental",
      description: "",
    },
    {
      icon: <FaClipboardCheck />,
      title: "Auditoria",
      description: "",
    },
    {
      icon: <FaLayerGroup />,
      title: "E mais",
      description: "",
    },
  ];

  const handleLogin = async () => {
    const result = await login(usuario, password);
    if (result.success) {
      navigate("/Menu");
    } else {
      const msgEl = document.getElementById("msm_senha");
      if (msgEl) {
        msgEl.innerText = result.message || "Usuario e senha nao conferem.";
        msgEl.style.display = "block";
      }
    }
  };

  return (
    <div className="TelaLoginInicial">
      <div className="PainelLogin">
        <div className="login-shell">
          <section className="login-container">
            <div className="login-container__halo"></div>
            <div className="login-stack">
              <div className="login-showcase__hero">
                <div className="login-showcase__logoWrap">
                  <img src={Logo} alt="Logo PentaGov" className="login-showcase__logo" />
                </div>
              </div>

            <form
              className="login-form"
              onSubmit={(e) => {
                e.preventDefault();
                handleLogin();
              }}
            >
              <div className="login-form__header">
                <div className="login-form__brandmark"></div>
              </div>

              <div className="form-group mb-3" align="left">
                <label className="login-label" htmlFor="login-email">
                  Usuario
                </label>
                <input
                  id="login-email"
                  type="text"
                  className="form-control form-control-lg"
                  placeholder="Digite seu usuario"
                  value={usuario}
                  onChange={(e) => setUsuario(e.target.value)}
                />
              </div>

              <div className="form-group mb-3" align="left" style={{ position: "relative" }}>
                <label className="login-label" htmlFor="login-password">
                  Senha
                </label>
                <input
                  id="login-password"
                  type={passwordVisible ? "text" : "password"}
                  className="form-control form-control-lg"
                  placeholder="Digite sua senha"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  style={{ paddingRight: "3rem" }}
                />
                <span onClick={() => setPasswordVisible((prev) => !prev)} className="password-toggle">
                  {passwordVisible ? <FaEyeSlash /> : <FaEye />}
                </span>
              </div>

              <button type="submit" className="btn btn-primary btn-lg w-100 login-submit">
                Entrar <FaArrowRight />
              </button>

              <label id="msm_senha" className="login-error"></label>

              <div className="mt-3 text-center login-links">
                <button
                  type="button"
                  className="link-recuperar"
                  onClick={() => navigate("/recuperar-senha")}
                >
                  Esqueci minha senha
                </button>
              </div>
            </form>
              <div className="login-showcase__grid">
                {presentationItems.map((item) => (
                  <article key={item.title} className="showcase-card">
                    <span className="showcase-card__icon">{item.icon}</span>
                    <div>
                      <strong>{item.title}</strong>
                    </div>
                  </article>
                ))}
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Index;
